require("stylesheets/components/buttons/iconButton.scss");

class IconButton{
  constructor(className){
    this.className = className;

    this.domNode = document.createElement('div');
    this.domNode.classList.add('iconButton');
    this.domNode.classList.add(className);
    this.clickListeners = [];

    this.domNode.addEventListener('click', this.onClick.bind(this));
  }

  onClick(evt){
    this.clickListeners.forEach((cl)=> cl.click(evt));
  }
}

var toExport = {
  IconButton
};

if(typeof module !== 'undefined' && typeof module.exports !== 'undefined'){
  module.exports = toExport;
} else {
  Object.assign(window, toExport);
}



/** WEBPACK FOOTER **
 ** ./src/components/buttons/iconButton.js
 **/